import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
import Vue from 'vue'

import ApplicationApi from '@/api/applicationApi'
const apiApplication = new ApplicationApi
import axios from 'axios'

export default class NotificationApi {

  async joinToChat(chatKey,chatKey2,chatType) {
    let joinToChat = await import('./graphql/notifications/joinToChat.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${joinToChat}`,
        variables: {chatKey,chatKey2,chatType}
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async exitChat(chatKey,chatKey2,chatType) {
    let exitChat = await import('./graphql/notifications/exitChat.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${exitChat}`,
        variables: {chatKey,chatKey2,chatType}
      })
      // .catch(error => Vue.prototype.$log_error(error.message))
  }

  async signLastVisit(chatKey,chatKey2,chatType) {
    let signLastVisit = await import('./graphql/notifications/signLastVisit.graphql')
    return (await getApolloClient())
      .mutate({
        mutation: gql`${signLastVisit}`,
        variables: {chatKey,chatKey2,chatType}
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async updateSubscription(model) {
    let updateSubscription = await import('./graphql/notifications/updateSubscription.graphql')
    return (await getApolloClient('/notifications'))
      .mutate({
        mutation: gql`${updateSubscription}`,
        variables: {model}
      })
  }

  async getSubscriptions(model) {
    let checkExistingSubscriptions = await import('./graphql/notifications/subscriptions.graphql')
    return (await getApolloClient('/notifications'))
      .query({
        query: gql`${checkExistingSubscriptions}`,
        variables: {model}
      })
  }

  async getNotifications(model) {
    let getNotifications = await import('./graphql/notifications/notifications.graphql')
    return (await getApolloClient('/notifications'))
      .query({
        query: gql`${getNotifications}`,
        variables: {model}
      })
  }

  async getNotificationsList(pagination) {
    pagination = pagination || {page: 1, size: 20}
    let notificationsList = await import('./graphql/notifications/notificationsList.graphql')
    return (await getApolloClient('/notifications'))
      .query({
        query: gql`${notificationsList}`,
        variables: {pagination}
      })
  }

  async setNotificationViewed(notificationIds) {
    let setNotificationViewed = await import('./graphql/notifications/setNotificationViewed.graphql')
    return (await getApolloClient('/notifications'))
      .mutate({
        mutation: gql`${setNotificationViewed}`,
        variables: {notificationIds}
      })
  }

  async getNotificationContent(notificationId) {
    if (!notificationId) {
      return null
    }

    const headers = await apiApplication.getHeaders()

    const promises = async (notificationId) => {
      try {
        const res = await axios.get(
          `${window.config.GrapgQlUrl}/Notifications/${notificationId}/content`,
          {
            headers,
          }
        )
        if (res.data) {
          return res.data
        } else {
          return
        }
      } catch (_) {
        return
      }
    }

    try {
      return await promises(notificationId)
    } catch (_) {
      return null
    }

  }
}
